export default [
  {
    path: '/settings/administrator/profiles',
    name: 'administrator-profiles',
    component: () => import('@/views/administrator/profile/ProfileList.vue'),
    meta: {
      pageTitle: 'Planos',
      breadcrumb: [
        {
          text: 'Configurações',
          toName: 'administrator-profiles',
        },
        {
          text: 'Sistema',
          toName: 'administrator-profiles',
        },
        {
          text: 'Planos',
          toName: 'administrator-profiles',
        },
      ],
      requireLogin: true,
      resource: 'Admin',
      action: 'read',
      icon: 'SettingsIcon',
    },
  },
  {
    path: '/settings/administrator/profiles/create',
    name: 'administrator-profiles-create',
    component: () => import('@/views/administrator/profile/ProfileEdit.vue'),
    meta: {
      pageTitle: 'Planos',
      breadcrumb: [
        {
          text: 'Configurações',
          toName: 'administrator-profiles',
        },
        {
          text: 'Sistema',
          toName: 'administrator-profiles',
        },
        {
          text: 'Planos',
          toName: 'administrator-profiles',
        },
        {
          text: 'Adicionar',
          active: true,
        },
      ],
      requireLogin: true,
      resource: 'Admin',
      action: 'create',
      icon: 'SettingsIcon',
    },
  },
  {
    path: '/settings/administrator/profiles/edit/:id',
    name: 'administrator-profiles-edit',
    component: () => import('@/views/administrator/profile/ProfileEdit.vue'),
    meta: {
      pageTitle: 'Planos',
      breadcrumb: [
        {
          text: 'Configurações',
          toName: 'administrator-profiles',
        },
        {
          text: 'Sistema',
          toName: 'administrator-profiles',
        },
        {
          text: 'Planos',
          toName: 'administrator-profiles',
        },
        {
          prefix: '#',
          routerParam: 'id',
          toName: 'administrator-profiles-edit',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      requireLogin: true,
      resource: 'Admin',
      action: 'update',
      icon: 'SettingsIcon',
    },
  },
]
